var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "m-5 md:m-15 2xl:m-20",
    on: {
      "keydown": function ($event) {
        return _vm.progressbar.userKeyDown();
      },
      "keyup": function ($event) {
        return _vm.progressbar.userKeyUp();
      },
      "click": _vm.calculate_progress
    }
  }, [_c('h3', {
    staticClass: "mb-15 2xl:mb-20 w-full",
    attrs: {
      "id": "form-situation-pro"
    }
  }, [_vm._v("Situation Professionnelle")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-10"
  }, [_c('input-text', {
    staticClass: "md:col-span-6",
    attrs: {
      "name": "poste_actuel",
      "libelle": "Poste principal actuel",
      "label-libelle": "Fonction principale occupée par le salarié au sein de l'entreprise.",
      "value": _vm.form.poste_actuel,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.poste_actuel = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    class: _vm.form.situation_anterieure === 'Autre' ? 'md:col-span-3' : 'md:col-span-6',
    attrs: {
      "name": "situation_anterieure",
      "libelle": "Situation antérieure à l'entrée dans la structure",
      "value": _vm.form.situation_anterieure,
      "datas": [{
        value: 'Demandeur d\'Emploi'
      }, {
        value: 'Scolarité classique ou Formation'
      }, {
        value: 'Institution ou Service Spécialisé (IME, SIPFP, IES, IEM...)'
      }, {
        value: 'Service d\'Accompagnement Social (SSAD, SESSAD, SAVS...)'
      }, {
        value: 'Etablissement et Service d\'Aide par le Travail (ESAT)'
      }, {
        value: 'Entreprise Adaptée (EA)'
      }, {
        value: 'Centre de Distribution de Travail à Domicile (CDTD)'
      }, {
        value: 'Entreprise d\'Insertion (EI)'
      }, {
        value: 'Entreprise de Travail Temporaire (ETT, ETTI)'
      }, {
        value: 'Milieu Ordinaire / Handicap'
      }, {
        value: 'Milieu Ordinaire / Inaptitude'
      }, {
        value: 'Institution Sanitaire (CHR, CHS, CRF...) / Hospitalisation'
      }, {
        value: 'Autre'
      }],
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.situation_anterieure = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "leave-active-class": "ease-out duration-300",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.situation_anterieure === 'Autre' ? _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "situation_anterieure_precis",
      "libelle": "Autre situation",
      "value": _vm.form.situation_anterieure_precis,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.situation_anterieure_precis = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "employeur_actuel",
      "libelle": "Nom de l'employeur actuel",
      "value": _vm.form.employeur_actuel,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.employeur_actuel = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "site",
      "libelle": "Lieu de travail",
      "label-libelle": "Zone géographique où une personne exerce son activité professionnelle (INSEE). Par convention, les personnes exerçant des professions les amenant à se déplacer plus ou moins fréquemment sont considérées comme travaillant dans leur commune de résidence.",
      "value": _vm.form.site,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.site = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "service",
      "libelle": "Service / secteur",
      "label-libelle": "Regroupement d’un ensemble de métiers appartenant à la même spécialité (Sous-Traitance Industrielle, Espaces verts, Electricité, Electronique...)",
      "value": _vm.form.service,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.service = newValue;
      }
    }
  }), _vm._v(" "), _c('date-picker', {
    staticClass: "col-span-full md:col-span-3",
    attrs: {
      "name": "date_structure",
      "necessary-date": true,
      "libelle": "Date d'entrée dans la structure",
      "format": "dd/MM/yyyy",
      "initialview": "year",
      "value": _vm.form.date_structure,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.date_structure = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "responsable",
      "libelle": "Responsable hiérarchique",
      "value": _vm.form.responsable,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.responsable = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "anciennete_poste",
      "libelle": "Ancienneté dans le poste",
      "value": _vm.form.anciennete_poste,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.anciennete_poste = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "type_contrat",
      "libelle": "Type de contrat",
      "value": _vm.form.type_contrat,
      "datas": [{
        value: 'Contrat de soutien et d\'aide par le travail'
      }, {
        value: 'Contrat de travail à durée indéterminée'
      }, {
        value: 'Contrat de travail à durée déterminée'
      }, {
        value: 'Contrat d\'apprentissage'
      }, {
        value: 'Contrat de prestation de service'
      }, {
        value: 'Contrat de professionnalisation'
      }, {
        value: 'Contrat de travail intérimaire'
      }, {
        value: 'Contrat unique d\'insertion - Secteur privé'
      }, {
        value: 'Contrat unique d\'insertion - Secteur public'
      }, {
        value: 'Autres contrats'
      }],
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.type_contrat = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "leave-active-class": "ease-out duration-300",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.type_contrat === 'Autres contrats' ? _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "type_contrat_precis",
      "libelle": "Autre type de contrat",
      "value": _vm.form.type_contrat_precis,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.type_contrat_precis = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "temps_travail",
      "libelle": "Temps de travail",
      "value": _vm.form.temps_travail,
      "datas": [{
        value: 'Temps plein'
      }, {
        value: 'Temps partiel'
      }],
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.temps_travail = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "horaires",
      "libelle": "Horaires",
      "value": _vm.form.horaires,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.horaires = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "qualification",
      "libelle": "Qualification",
      "label-libelle": "Appréciation, sur une grille hiérarchique, de la valeur professionnelle d'un salarié, en fonction de sa formation initiale, de son expérience professionnelle, de la nature de son travail et de son niveau de responsabilité.",
      "value": _vm.form.qualification,
      "datas": [{
        value: 'Non précisé'
      }, {
        value: 'Manoeuvres'
      }, {
        value: 'Ouvriers non qualifiés'
      }, {
        value: 'Ouvriers qualifiés'
      }, {
        value: 'Employés non qualifiés'
      }, {
        value: 'Employés qualifiés'
      }, {
        value: 'Techniciens'
      }, {
        value: 'Ingénieurs et cadres'
      }, {
        value: 'Autres'
      }],
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.qualification = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "leave-active-class": "ease-out duration-300",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.qualification === 'Autres' ? _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "qualification_precis",
      "libelle": "Autre qualification",
      "value": _vm.form.qualification_precis,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.qualification_precis = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "statut2",
      "libelle": "Statut",
      "label-libelle": "Notion qui permet de distinguer les actifs ayant un emploi suivant un ensemble de droits et de devoirs acquis ou prescris. Elle permet de repérer où l'individu se situe dans le système social.",
      "value": _vm.form.statut2,
      "datas": [{
        value: 'Usager'
      }, {
        value: 'Salarié handicapé bénéficiant de l\'aide au poste'
      }, {
        value: 'Salarié valide'
      }, {
        value: 'Salarié handicapé ne bénéficiant pas de l\'aide au poste'
      }, {
        value: 'Intérimaire'
      }, {
        value: 'Stagiaire'
      }, {
        value: 'Compagne / Compagnon'
      }, {
        value: 'Autre'
      }],
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.statut2 = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-in duration-300",
      "enter-class": "opacity-0",
      "leave-active-class": "ease-out duration-300",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.form.statut2 === 'Autre' ? _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "statut2_precis",
      "libelle": "Autre statut",
      "value": _vm.form.statut2_precis,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.statut2_precis = newValue;
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "remuneration",
      "libelle": "Rémunération (mens. brute €)",
      "replace-tooltip-libelle": "Rémunération (mensuelle brute €)",
      "value": _vm.form.remuneration,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.remuneration = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-3",
    attrs: {
      "name": "dif",
      "libelle": "Crédit CPF",
      "label-libelle": "Notion qui permet de distinguer les actifs ayant un emploi suivant un ensemble de droits et de devoirs acquis ou prescris. Elle permet de repérer où l'individu se situe dans le système social.",
      "value": _vm.form.dif,
      "necessary": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.dif = newValue;
      }
    }
  })], 1), _vm._v(" "), _vm.$can('situationprofessionnelle_edit') || _vm.form.habilitation_pro.length > 0 ? _c('hr', {
    staticClass: "border-dashed border-gray-600 my-10"
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.form.habilitation_pro, function (habilitation, index) {
    return _c('div', {
      key: index,
      staticClass: "transition-all duration-300 flex mb-10 space-x-4",
      class: {
        'pb-10 border-b border-gray-600': index < _vm.form.habilitation_pro.length - 1
      }
    }, [_c('delete-button', {
      staticClass: "pt-6",
      on: {
        "del": function ($event) {
          return _vm.deleteItem(_vm.form.habilitation_pro, index);
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "grid grid-cols-12 gap-x-4 gap-y-10 w-full"
    }, [_c('input-select', {
      class: habilitation.habilitation_type == 'Autres' ? 'md:col-span-2' : 'md:col-span-4',
      attrs: {
        "name": 'habilitation_type' + index,
        "necessary": true,
        "libelle": "Habilitations électriques",
        "label-libelle": "L'habilitation électrique est une exigence réglementaire pour tous les travailleurs qui effectuent des opérations sur les installations électriques ou dans leur voisinage. Elle nécessite une formation préalable.#Le titre d’habilitation est ensuite délivré par l’employeur. Il forme la reconnaissance, par un employeur de la capacité d’une personne à accomplir en sécurité les tâches fixées. L’habilitation n’est pas un document lié à la position hiérarchique ni à la classification professionnelle. L’habilitation est matérialisée par un document établi par l’employeur et signé par l’employeur et par l’habilité. La délivrance d’une habilitation par l’employeur ne dégage pas pour autant la responsabilité de ce dernier. L’habilitation n’autorise pas, à elle seule, un titulaire à effectuer de son propre chef des opérations pour lesquelles il est habilité. Il doit en outre être désigné par son employeur pour l’exécution de ces opérations. L’affectation à un poste de travail peut constituer une désignation implicite.",
        "value": habilitation.habilitation_type,
        "datas": [{
          group: 'Type B',
          value: 'B0'
        }, {
          group: 'Type B',
          value: 'B1'
        }, {
          group: 'Type B',
          value: 'B2'
        }, {
          group: 'Type B',
          value: 'BC'
        }, {
          group: 'Type B',
          value: 'BR'
        }, {
          group: 'Type B',
          value: 'BS'
        }, {
          group: 'Type B',
          value: 'BP'
        }, {
          group: 'Type B',
          value: 'BE'
        }, {
          group: 'Type H',
          value: 'H0'
        }, {
          group: 'Type H',
          value: 'H1'
        }, {
          group: 'Type H',
          value: 'H2'
        }, {
          group: 'Type H',
          value: 'HC'
        }, {
          group: 'Type H',
          value: 'HR'
        }, {
          group: 'Type H',
          value: 'HS'
        }, {
          group: 'Type H',
          value: 'HP'
        }, {
          group: 'Type H',
          value: 'HE'
        }, {
          group: ' ',
          value: 'Autres'
        }]
      },
      on: {
        "input": function (newValue) {
          habilitation.habilitation_type = newValue;
        }
      }
    }), _vm._v(" "), _c('transition', {
      attrs: {
        "enter-active-class": "ease-in duration-300",
        "enter-class": "opacity-0",
        "leave-active-class": "ease-out duration-300",
        "leave-to-class": "opacity-0"
      }
    }, [habilitation.habilitation_type == 'Autres' ? _c('input-text', {
      staticClass: "md:col-span-2",
      attrs: {
        "necessary": true,
        "name": 'habilitation_type_precis' + index,
        "libelle": "Autre habilitation",
        "value": habilitation.habilitation_type_precis
      },
      on: {
        "input": function (newValue) {
          habilitation.habilitation_type_precis = newValue;
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('input-text', {
      staticClass: "md:col-span-4",
      attrs: {
        "name": 'habilitation_autorite' + index,
        "necessary": true,
        "libelle": "Autorité délivrante",
        "value": habilitation.habilitation_autorite
      },
      on: {
        "input": function (newValue) {
          habilitation.habilitation_autorite = newValue;
        }
      }
    }), _vm._v(" "), _c('date-picker', {
      staticClass: "col-span-full md:col-span-4",
      attrs: {
        "format": "dd/MM/yyyy",
        "necessary-date": true,
        "initialview": "year",
        "name": 'habilitation_date' + index,
        "libelle": "Date de fin de validité",
        "value": habilitation.habilitation_date
      },
      on: {
        "input": function (newValue) {
          habilitation.habilitation_date = newValue;
        }
      }
    })], 1)], 1);
  }), _vm._v(" "), _c('add-button', {
    attrs: {
      "id": "form-habilitation",
      "libelle": "Ajouter une habilitation"
    },
    on: {
      "add": function ($event) {
        return _vm.addItem(_vm.form.habilitation_pro, _vm.habilitation_pro);
      }
    }
  }), _vm._v(" "), _vm.$can('situationprofessionnelle_edit') || _vm.form.autorisation_exercice.length > 0 ? _c('hr', {
    staticClass: "border-dashed border-gray-600 my-10"
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.form.autorisation_exercice, function (autorisation, index) {
    return _c('div', {
      key: index,
      staticClass: "transition-all duration-300 flex mb-10 space-x-4",
      class: {
        'pb-10 border-b border-gray-600': index < _vm.form.autorisation_exercice.length - 1
      }
    }, [_c('delete-button', {
      staticClass: "pt-6",
      on: {
        "del": function ($event) {
          return _vm.deleteItem(_vm.form.autorisation_exercice, index);
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "grid grid-cols-12 gap-x-4 gap-y-10 w-full"
    }, [_c('input-select', {
      class: autorisation.autorisation_type == 'Autres' ? 'md:col-span-2' : 'md:col-span-4',
      attrs: {
        "name": 'autorisation_type' + index,
        "necessary": true,
        "libelle": "Certificats d'Autorisation d'Exercice",
        "label-libelle": "<div class='block'><b>Le Certificat d’Aptitude à la Conduite en Sécurité</b>, abrégé en CACES, permet de valider, pour l'essentiel, la conduite d'engins de manutention. Celui-ci n'est pas un certificat de compétences professionnelles (au sens métier du terme), c'est une validation obtenue au travers d'un test théorique et pratique des connaissances de l'opérateur pour la conduite en sécurité du matériel concerné.<br /><br />\n                                    <div class='block'><b>Le Service de Sécurité Incendie et d’Assistance à Personnes</b>, abrégé en SSIAP regroupe un ensemble de connaissances nécessaires pour assurer la sécurité des personnes et la sécurité incendie des biens au sein des Établissements Recevant du Public (ERP) et des Immeubles de Grandes Hauteurs (IGH). Il permet d’assurer la fonction d’Agent de Sécurité Incendie. Trois catégories de personnels sont présents dans un service de sécurité incendie et d'assistance aux personnes:\n                                    <div>\n                                    <ul class='list-disc list-inside'>\n                                    <li>L'agent de service de sécurité incendie et d'assistance aux personnes (il est titulaire du diplôme SSIAP1)</li>\n                                    <li>Le chef d'équipe sécurité incendie et d'assistance aux personnes (titulaire du SSIAP2)</li>\n                                    <li>Le chef de service de sécurité incendie et d'assistance aux personnes (titulaire du SSIAP3).</li></ul>",
        "value": autorisation.autorisation_type,
        "datas": [{
          value: 'CACES1'
        }, {
          value: 'CACES2'
        }, {
          value: 'CACES3'
        }, {
          value: 'CACES4'
        }, {
          value: 'CACES5'
        }, {
          value: 'CACES6'
        }, {
          value: 'CACES7'
        }, {
          value: 'CACES8'
        }, {
          value: 'CACES9'
        }, {
          value: 'CACES10'
        }, {
          value: 'Autres'
        }]
      },
      on: {
        "input": function (newValue) {
          autorisation.autorisation_type = newValue;
        }
      }
    }), _vm._v(" "), _c('transition', {
      attrs: {
        "enter-active-class": "ease-in duration-300",
        "enter-class": "opacity-0",
        "leave-active-class": "ease-out duration-300",
        "leave-to-class": "opacity-0"
      }
    }, [autorisation.autorisation_type == 'Autres' ? _c('input-text', {
      staticClass: "md:col-span-2",
      attrs: {
        "necessary": true,
        "name": 'autorisation_type_precis' + index,
        "libelle": "Autre type de certificat",
        "value": autorisation.autorisation_type_precis
      },
      on: {
        "input": function (newValue) {
          autorisation.autorisation_type_precis = newValue;
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('input-text', {
      staticClass: "md:col-span-4",
      attrs: {
        "name": 'autorisation_autorite' + index,
        "necessary": true,
        "libelle": "Autorité délivrante",
        "value": autorisation.autorisation_autorite
      },
      on: {
        "input": function (newValue) {
          autorisation.autorisation_autorite = newValue;
        }
      }
    }), _vm._v(" "), _c('date-picker', {
      staticClass: "col-span-full md:col-span-4",
      attrs: {
        "name": 'autorisation_date' + index,
        "necessary-date": true,
        "format": "dd/MM/yyyy",
        "initialview": "year",
        "libelle": "Date de fin de validité",
        "value": autorisation.autorisation_date
      },
      on: {
        "input": function (newValue) {
          autorisation.autorisation_date = newValue;
        }
      }
    })], 1)], 1);
  }), _vm._v(" "), _c('add-button', {
    attrs: {
      "id": "form-certif",
      "libelle": "Ajouter un certificat d'autorisation d'exercice"
    },
    on: {
      "add": function ($event) {
        return _vm.addItem(_vm.form.autorisation_exercice, _vm.autorisation_exercice);
      }
    }
  }), _vm._v(" "), _vm.$can('situationprofessionnelle_edit') || _vm.form.connaissances_securite_incendie.length > 0 ? _c('hr', {
    staticClass: "border-dashed border-gray-600 my-10"
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.form.connaissances_securite_incendie, function (connaissance, index) {
    return _c('div', {
      key: index,
      staticClass: "transition-all duration-300 flex mb-10 space-x-4",
      class: {
        'pb-10 border-b border-gray-600': index < _vm.form.connaissances_securite_incendie.length - 1
      }
    }, [_c('delete-button', {
      staticClass: "pt-6",
      on: {
        "del": function ($event) {
          return _vm.deleteItem(_vm.form.connaissances_securite_incendie, index);
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "grid grid-cols-12 gap-x-4 gap-y-10 w-full"
    }, [_c('input-select', {
      class: connaissance.securite_incendie == 'Autres' ? 'md:col-span-2' : 'md:col-span-4',
      attrs: {
        "name": 'securite_incendie' + index,
        "necessary": true,
        "libelle": "Secours - Sécurité Incendie",
        "value": connaissance.securite_incendie,
        "datas": [{
          value: 'PSC1'
        }, {
          value: 'PSE1'
        }, {
          value: 'SST'
        }, {
          value: 'SSIAP1'
        }, {
          value: 'SSIAP2'
        }, {
          value: 'SSIAP3'
        }, {
          value: 'Autres'
        }]
      },
      on: {
        "input": function (newValue) {
          connaissance.securite_incendie = newValue;
        }
      }
    }), _vm._v(" "), _c('transition', {
      attrs: {
        "enter-active-class": "ease-in duration-300",
        "enter-class": "opacity-0",
        "leave-active-class": "ease-out duration-300",
        "leave-to-class": "opacity-0"
      }
    }, [connaissance.securite_incendie == 'Autres' ? _c('input-text', {
      staticClass: "md:col-span-2",
      attrs: {
        "necessary": true,
        "name": 'securite_incendie_precis' + index,
        "libelle": "Autre",
        "value": connaissance.securite_incendie_precis
      },
      on: {
        "input": function (newValue) {
          connaissance.securite_incendie_precis = newValue;
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('input-text', {
      staticClass: "md:col-span-4",
      attrs: {
        "name": 'secours_autorite' + index,
        "necessary": true,
        "libelle": "Autorité délivrante",
        "value": connaissance.secours_autorite
      },
      on: {
        "input": function (newValue) {
          connaissance.secours_autorite = newValue;
        }
      }
    }), _vm._v(" "), _c('date-picker', {
      staticClass: "col-span-full md:col-span-4",
      attrs: {
        "name": 'secours_date' + index,
        "necessary-date": true,
        "format": "dd/MM/yyyy",
        "initialview": "year",
        "libelle": "Date de fin de validité",
        "value": connaissance.secours_date
      },
      on: {
        "input": function (newValue) {
          connaissance.secours_date = newValue;
        }
      }
    })], 1)], 1);
  }), _vm._v(" "), _c('add-button', {
    attrs: {
      "id": "form-diplome",
      "libelle": "Ajouter un diplôme en \"Secours - Sécurité Incendie\""
    },
    on: {
      "add": function ($event) {
        return _vm.addItem(_vm.form.connaissances_securite_incendie, _vm.connaissances_securite_incendie);
      }
    }
  }), _vm._v(" "), _c('hr', {
    staticClass: "border-dashed border-gray-600 my-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-10"
  }, [_c('checkbox-indigo', {
    staticClass: "col-span-full md:col-span-6 place-self-start",
    attrs: {
      "name": "aptitude_medicale",
      "libelle": "Aptitude médicale au poste de travail",
      "label-libelle": "Délivré par le médecin du travail, il donne un avis sur l'aptitude médicale du salarié à son poste de travail après l'une des visites médicales prévue par les articles R.4624-10 et suivants du Code du travail. Il pourra s'agir soit d'une visite médicale d'embauche, soit d'une visite médicale périodique, soit enfin d'une visite médicale de reprise.",
      "value": _vm.form.aptitude_medicale,
      "is-checkbox-right": true
    },
    on: {
      "input": function (newValue) {
        _vm.form.aptitude_medicale = newValue;
      }
    }
  }), _vm._v(" "), _vm.form.aptitude_medicale ? _c('date-picker', {
    staticClass: "col-span-full md:col-span-6",
    attrs: {
      "necessary-date": true,
      "format": "dd/MM/yyyy",
      "initialview": "year",
      "name": "aptitude_validite",
      "libelle": "Fin de validité de la visite médicale",
      "value": _vm.form.aptitude_validite
    },
    on: {
      "input": function (newValue) {
        _vm.form.aptitude_validite = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "duration-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100"
    }
  }, [_vm.form.aptitude_medicale ? _c('div', {
    staticClass: "col-span-full grid grid-cols-12 gap-x-4 gap-y-10"
  }, [_c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "aptitude_partielle",
      "necessary": true,
      "libelle": "Avis d'inaptitude au poste de travail 1/2",
      "label-libelle": "Elle est prononcée, après un examen médical et une étude de poste, par le médecin du travail dont la mission est de vérifier la compatibilité de la santé du salarié avec le travail à effectuer et de proposer les aménagements nécessaires. À ne pas confondre avec l’arrêt de travail délivré par un médecin ou encore avec l’invalidité, décidée par le médecin conseil de la caisse primaire d’assurance maladie (CPAM).",
      "value": _vm.form.aptitude_partielle,
      "datas": [{
        value: 'Partielle'
      }, {
        value: 'Totale'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.aptitude_partielle = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "aptitude_temporaire",
      "necessary": true,
      "libelle": "Avis d'inaptitude au poste de travail 2/2",
      "value": _vm.form.aptitude_temporaire,
      "datas": [{
        value: 'Temporaire'
      }, {
        value: 'Définitive'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.aptitude_temporaire = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "aptitude_delivre",
      "necessary": true,
      "libelle": "Délivré par",
      "value": _vm.form.aptitude_delivre
    },
    on: {
      "input": function (newValue) {
        _vm.form.aptitude_delivre = newValue;
      }
    }
  }), _vm._v(" "), _c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "invalidite",
      "necessary": true,
      "libelle": "Invalidité",
      "label-libelle": "L’invalidité est décidée par le médecin conseil de la CPAM. C’est une réduction de la capacité de travail du salarié, elle dépend du code de la sécurité sociale.",
      "value": _vm.form.invalidite,
      "datas": [{
        value: 'Oui'
      }, {
        value: 'Non'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.invalidite = newValue;
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "duration-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100"
    }
  }, [_vm.form.invalidite == 'Oui' ? _c('div', {
    staticClass: "col-span-full md:col-span-8 grid grid-cols-8 gap-x-4 gap-y-10"
  }, [_c('input-select', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "categorie_invalidite",
      "necessary": true,
      "libelle": "Avis d'inaptitude au poste de travail 1/2",
      "value": _vm.form.categorie_invalidite,
      "datas": [{
        value: '1ère catégorie'
      }, {
        value: '2ème catégorie'
      }, {
        value: '3ème catégorie'
      }]
    },
    on: {
      "input": function (newValue) {
        _vm.form.categorie_invalidite = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "md:col-span-4",
    attrs: {
      "name": "invalidite_delivre",
      "necessary": true,
      "libelle": "Délivré par",
      "value": _vm.form.invalidite_delivre
    },
    on: {
      "input": function (newValue) {
        _vm.form.invalidite_delivre = newValue;
      }
    }
  })], 1) : _vm._e()])], 1) : _vm._e()]), _vm._v(" "), _c('input-text-area', {
    staticClass: "col-span-full",
    attrs: {
      "name": "recommandations2",
      "libelle": "Recommandations et propositions de mesures individuelles",
      "size": 5,
      "value": _vm.form.recommandations2
    },
    on: {
      "input": function (newValue) {
        _vm.form.recommandations2 = newValue;
      }
    }
  })], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }